import { useEffect } from "react";
import axios from "axios";
import "./App.css";

function App() {
  useEffect(() => {
    const detectLocation = async () => {
      try {
        // Get IP-based location
        const res = await axios.get("https://ipapi.co/json/");
        const countryCode = res.data.country_code?.toLowerCase();

        if (countryCode) {
          const subdomain = `${countryCode}.alihussain.eu`;

          // Prevent redirect loop if already on correct subdomain
          if (!window.location.hostname.startsWith(countryCode)) {
            window.location.href = `https://${subdomain}`;
          }
        }
      } catch (err) {
        console.error("Location detection failed:", err);
      }
    };

    detectLocation();
  }, []);

  return (
    <div className="app">
      <h1>Detecting your location...</h1>
      <p>You will be redirected to your country-specific website.</p>
    </div>
  );
}

export default App;
